// Spec 39. GDPR consent gate for PostHog. PostHog inits opted-out, so nothing
// (events, pageviews, session recording) is captured until the user accepts
// here. Shown only while the explicit consent status is "pending".

import { useState } from "react";

import { GlassPanel, Pill } from "@/components/glass";
import { analytics } from "@/lib/analytics";
import { useSession } from "@/lib/auth-client";

export function ConsentBanner() {
	const session = useSession();
	const [status, setStatus] = useState(() => analytics.consentStatus());

	if (status !== "pending") return null;

	const accept = () => {
		analytics.optIn();
		// Capturing was off when the identity bridge first ran, so re-identify
		// the (already signed-in) user now that we're allowed to.
		const user = session.data?.user;
		if (user) {
			const activeOrgId =
				(
					session.data?.session as {
						activeOrganizationId?: string | null;
					} | null
				)?.activeOrganizationId ?? null;
			analytics.identify(
				{ id: user.id, email: user.email, name: user.name },
				activeOrgId,
			);
		}
		setStatus("granted");
	};

	const decline = () => {
		analytics.optOut();
		setStatus("denied");
	};

	return (
		<GlassPanel
			variant="hi"
			className="fixed bottom-4 left-4 z-[100] w-[320px] p-4 space-y-3"
		>
			<div className="text-[12px] text-[var(--color-text-muted)] leading-relaxed">
				We use cookies and session recording to understand how the product is
				used and improve onboarding. Inputs are masked.
			</div>
			<div className="flex items-center gap-2">
				<Pill onClick={accept} className="flex-1 justify-center">
					Accept
				</Pill>
				<button
					type="button"
					onClick={decline}
					className="text-[12px] px-3 py-1.5 text-[var(--color-text-dim)] hover:text-[var(--color-text)] transition-colors"
				>
					Decline
				</button>
			</div>
		</GlassPanel>
	);
}
